import { MousePointerClick } from 'lucide-react';
import { FC } from 'react';
import StudentLearnInteractiveCard from './StudentLearnInteractiveCard';

const interactiveCardData = [
  {
    header: 'Grades 4–6',
    title: 'Area & Perimeter',
  },
  {
    header: 'Grades 7–Algebra',
    title: 'Proportional Graphs',
  },
];

const StudentLearnInteractive: FC = () => {
  return (
    <div className="nc_student-learn-interactive">
      <div className="tw-flex tw-flex-col tw-gap-y-6 tw-w-[48%]">
        <span className="tw-mr-auto tw-border-2 tw-border-solid tw-border-amber-200 tw-bg-amber-100 tw-text-amber-800 tw-text-xs tw-font-bold tw-rounded-xl tw-px-2 tw-py-1 tw-flex tw-flex-row tw-gap-x-1 tw-items-center tw-font-atkinson">
          <MousePointerClick size={12} className="tw-text-neutral-950" />
          Interactive demo
        </span>
        <div className="tw-flex tw-flex-col">
          <h1 className="tw-text-xl tw-font-sora tw-text-white tw-font-bold"> Experience a Skill on your own</h1>
          <p className="tw-m-0 tw-text-base tw-font-atkinson tw-text-neutral-200">
            Open the interactive student view and walk through the same 4-step cycle as your students
          </p>
        </div>
      </div>
      <div className="tw-flex tw-flex-col tw-gap-y-3 tw-w-[48%]">
        <p className="tw-m-0 tw-text-xs tw-font-atkinson tw-text-neutral-100">Pick a grade band</p>
        <StudentLearnInteractiveCard data={interactiveCardData[0]} />
        <StudentLearnInteractiveCard data={interactiveCardData[1]} />
      </div>
    </div>
  );
};

export default StudentLearnInteractive;
